import Selector from "./selector";

export default Selector;
